import React, {useEffect, useState, useContext} from 'react';
import SelectField from '../../../../FormikUtils/SelectField'
import FormikSlider from "../../../../FormikUtils/FormikSlider";
import {Field, useFormikContext} from "formik";
import useStyles from "../styles";
import pdfTemplate from "../../../../../../../src/assets/images/pdftemplate.png"
import DiscountsContext from "../../../../../../context/DiscountsContext";
import RegularInputField from "../../../../../RegularInputField";
import Alert from "@material-ui/lab/Alert";
import {Grid, Snackbar} from "@material-ui/core";
import InputField from "../../../../FormikUtils/InputField";

const vigencias = [
    {value: '1', label: 'Anual'},
];

const carProdsDict = {
    "0": "Tercero básico",
    "1": "Tercero completo",
    "2": "Todo riesgo",
    "3": "Quiero conocer distintas opciones",
}

const cantCuotas = [
    {value: '1', label: '1'},
    {value: '2', label: '2'},
    {value: '3', label: '3'},
    {value: '4', label: '4'},
    {value: '5', label: '5'},
];

const ajuste = [
    {value: '0', label: 'No aplicar'},
    {value: '10', label: 'Aplicar 10%'},
    {value: '20', label: 'Aplicar 20%'},
    {value: '30', label: 'Aplicar 30%'},
];

const renderArchives = (archives) => (
    archives &&
    <>
        <div style={{display: 'flex', flexDirection: 'row', marginTop: '8px'}}>
            {archives.map(archive => (
                <div style={{marginRight: '16px'}}>
                    <a href={archive.link} download>
                        {archive['type'] === 'application/pdf' ? <img src={pdfTemplate} height={80}/> :
                            <img src={archive.link} height={80}/>}
                    </a>
                </div>

            ))}
        </div>
    </>
)


export default function CoberturaForm(props) {
    const classes = useStyles();
    const {
        formField: {
            vigencia,
            cuotas,
            ajusteAutomatico,
            descuentoExtra,
            descuentoEspecial,
            fechaCotizacion,
            vehiculo: {
                sumaAsegurada
            }
        },
        cotizacionRetomada
    } = props;
    const {values, setFieldValue} = useFormikContext();
    const {discounts} = useContext(DiscountsContext);
    const [descuentoExtraMaximo, setDescuentoExtraMaximo] = useState(0)
    const [descuentoEspecialMaximo, setDescuentoEspecialMaximo] = useState(0)
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const cotizacionResponse = props.cotizacionResponse;
    const setDescuentoEspecial = props.setDescuentoEspecial;

    useEffect(() => {
        setDescuentoEspecial(values.descuentoEspecial ?? 0)
    }, [values.descuentoEspecial])

    function handleValueChange(e) {
        let value = e.target.value;
        if (!value.match(/^[1-9]\d*$/))
            value = 0;
        else value = parseInt(value);
        let minValue = sumAsegurada
        let maxValue = sumAsegurada + (sumAsegurada * 0.4)

        if (value < minValue) {
            handleOpenAlert(`El valor mínimo para la suma asegurada es de $ ${minValue}`);
            value = minValue
        }
        if (value > maxValue) {
            handleOpenAlert(`El valor máximo para la suma asegurada es de $ ${maxValue}`);
            value = maxValue
        }
        setFieldValue("vehiculo.sumaAsegurada", value)
    }

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
        setAlertMessage(null);
    };

    let sumAsegurada;
    sumAsegurada = values.sumaAseguradaFirst > 0 ? values.sumaAseguradaFirst : (
        values.vehiculo.sumaAsegurada > 0 ? values.vehiculo.sumaAsegurada : null
    )

    useEffect(() => {
        if (descuentoExtraMaximo === 0) {
            const idAfinidad = parseInt(values.afinidad)
            const dmodelo = discounts[idAfinidad][0];
            const dextra = discounts[idAfinidad][1]
            setDescuentoExtraMaximo(dmodelo)
            setDescuentoEspecialMaximo(dextra)
        }
    }, []);

    return (
        <React.Fragment>
            <Grid container spacing={3}>

                <Grid item xs={12} sm={12}>
                    {cotizacionRetomada &&
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                    }}>
                        <p className={classes.coberturaFormTexts}>Producto seleccionado por el cliente: <span
                            style={{
                                fontWeight: "normal",
                                fontSize: "14px",
                            }}>{carProdsDict[values.carProdSelected]}</span>
                        </p>
                        <p className={classes.coberturaFormTexts}>Comentarios: <span
                            style={{fontWeight: "normal", fontSize: "14px",}}>{values.comments}</span>
                        </p>
                        <p className={classes.coberturaFormTexts}>Archivos:

                            {renderArchives(values.archivos)}
                        </p>
                    </div>}
                </Grid>

                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={vigencia.name}
                        label={vigencia.label}
                        data={vigencias}
                        disabled={vigencias.length <= 1}
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={fechaCotizacion.name}
                        label={fechaCotizacion.label}
                        type="date"
                        fullWidth
                        InputLabelProps={{shrink: true,}}
                        textTransform={'lowercase'}
                    />
                </Grid>

                {values.vigencia !== '1' && (
                    <Grid item xs={12} sm={6}>
                        <SelectField
                            name={cuotas.name}
                            label={cuotas.label}
                            data={cantCuotas}
                            fullWidth
                            textTransform={'uppercase'}
                        />
                    </Grid>
                )}

                {values.vigencia !== '1' && (
                    <Grid item xs={12} sm={6}>
                        <SelectField
                            name={ajusteAutomatico.name}
                            label={ajusteAutomatico.label}
                            data={ajuste}
                            fullWidth
                        />
                    </Grid>
                )}

                <Grid item xs={12} sm={6}>
                    {sumAsegurada &&
                    <RegularInputField
                        name={sumaAsegurada.name}
                        label={sumaAsegurada.label}
                        fullWidth
                        onBlur={(e) => handleValueChange(e)}
                    />}
                </Grid>
                {descuentoExtraMaximo > 0 &&
                <Grid item xs={12} sm={6}>
                    <Field
                        name={descuentoExtra.name}
                        label={descuentoExtra.label}
                        interval={5}
                        min={0}
                        max={descuentoExtraMaximo}
                        component={FormikSlider}
                    />
                </Grid>
                }

                <Grid item xs={12} sm={6}/>

                <Grid item xs={12} sm={6} style={{marginTop: "-16px"}}>
                    {values.descuentoExtra === descuentoExtraMaximo && values.descuentoExtra > 0 && descuentoEspecialMaximo > 0 &&
                    <Field
                        name={descuentoEspecial.name}
                        label={descuentoEspecial.label}
                        interval={5}
                        min={0}
                        max={descuentoEspecialMaximo}
                        component={FormikSlider}
                        alternative={true}
                        disabled={!cotizacionResponse}
                    />
                    }
                </Grid>
            </Grid>

            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled">
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
